module.exports = __webpack_public_path__ + "img/Sonder2017.a85462a7.jpg";